import { PickSessionSchema } from "@redotech/redo-model/wms/schema/pick-session";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getPickSession = {
  name: "getPickSession" as const,
  input: z.object({ id: zExt.objectId() }),
  output: PickSessionSchema.nullable(),
};
